<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="100px">
        <el-row :gutter="20">
           <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="回收商名称">
                <el-input
                clearable
                v-model="queryParamForm.serviceName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getWalletListSearch"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="code" label="钱包ID"> </el-table-column>
        <el-table-column prop="serviceId" label="回收商ID">
        </el-table-column>
        <el-table-column prop="serviceName" label="回收商名称"> </el-table-column>
        <el-table-column prop="balance" label="钱包余额（元）"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">启用</span>
            <span v-else>已禁用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel({id:scope.row.id,serviceName:scope.row.serviceName})" type="text" size="small"
              >明细</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0 && userInfo.data.roleId!=9"
              >启用</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else-if="userInfo.data.roleId!=9"
              >禁用</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        serviceName:null
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      userInfo:{},

      // 新建编辑对话框数据

      isDlg: false,
      editServiceProviderForm: {
        id: null,
        realName: null,
        serviceId: null,
        username: null,
        password:"123456"
      },

      dlgType: "change",

      // 选择
      loading: false,

      queryServiceList: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
      //回收商集合
    getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getWalletListSearch();
    },

    // 获取表格数据
    getWalletListSearch() {
      let self = this;
      self.$api
        .walletListSearch({
          page: self.currentPage,
          size: self.pageSize,
          serviceName: self.queryParamForm.serviceName || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

 

    // 修改
    editormodel(row) {
      console.log("=====sdfdsf===>",row)
        this.$router.push({path:'/index/serviceProviderManage/walletDetail', query: row});
    },

    changeStatus(row, newStatus) {
      let self = this;
      var updateParam = {walletId:row.id,status:newStatus};
      this.$api.enableWallet(updateParam).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getWalletListSearch();
        }
      });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getWalletListSearch();
    self.getServiceList();
    self.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
};
</script>
<style lang="less" scoped>
</style>
